import { render, staticRenderFns } from "./InformationAlert.vue?vue&type=template&id=a12dc71e"
import script from "./InformationAlert.vue?vue&type=script&lang=js"
export * from "./InformationAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports